<template>
  <div>
    <v-card>
      <v-toolbar dense card class="elevation-2">
        <v-tooltip bottom>
          <v-btn slot="activator" flat icon @click="backToList">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <span>Back</span>
        </v-tooltip>
        <div>
          Honey Form Designer
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn
            :outline="$vuetify.dark"
            :class="
              $vuetify.dark
                ? 'secondary text-capitalize'
                : 'primary text-capitalize'
            "
            icon
            :color="$vuetify.dark ? 'secondary' : ''"
            slot="activator"
            @click="save"
          >
            <v-icon>save</v-icon>
          </v-btn>
          <span>Save</span>
        </v-tooltip>
      </v-toolbar>
      <div class="px-3 pt-3" v-if="isHoneyFormCreate">
        <v-text-field
          color="secondary"
          autofocus
          label="Form Key"
          v-model="formKey"
          required
        >
        </v-text-field>
        <v-text-field
          color="secondary"
          label="Description"
          v-model="description"
          required
        >
        </v-text-field>
      </div>
    </v-card>
    <div class="mt-3">
      <transition name="bounce" mode="out-in">
        <proposal-designer
          :key="hexId + 'input-render'"
          :value="proposals"
          @input="getJsonProposal"
          v-if="proposals"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProposalDesigner from '@/components/bot-creation/ProposalDesigner'
import moment from 'moment'
import u from '@/utils'

export default {
  name: 'HoneyFormDesigner',
  components: {
    ProposalDesigner
  },

  props: {
    honeyForm: Object,
    hexId: String
  },

  data() {
    return {
      proposals: this.honeyForm ? this.honeyForm.proposals : [],
      formKey: '',
      description: ''
    }
  },

  computed: {
    ...mapGetters(['getHoneyForms']),
    isHoneyFormDetail() {
      return this.$route.name === 'honey-form-designer-detail'
    },
    isHoneyFormCreate() {
      return this.$route.name === 'honey-form-designer-create'
    }
  },

  async created() {
    if (this.isHoneyFormDetail) {
      let currentHoneyForm = {}
      if (!this.honeyForm) {
        try {
          currentHoneyForm = await this.$store.dispatch(
            'fetchHoneyForm',
            this.hexId
          )
          this.proposals = currentHoneyForm.proposals
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to fetch Form(s)',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
    }
  },

  methods: {
    async save() {
      if (this.isHoneyFormDetail) {
        try {
          let response = await this.$store.dispatch('updateHoneyForm', {
            body: { proposals: this.proposals },
            hexId: this.hexId
          })
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Form saved Successfully',
            description: `Form ${this.hexId} has been saved.`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to save form',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      } else if (this.isHoneyFormCreate) {
        try {
          let response = await this.$store.dispatch('saveHoneyForm', {
            formKey: this.formKey,
            description: this.description,
            proposals: this.proposals
          })

          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Form saved Successfully',
            description: 'Form has been saved.',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })

          this.$store.dispatch('fetchHoneyForms')
          this.$router
            .replace({
              name: 'honey-form-detail'
            })
            .catch()
        } catch (e) {
          if (e.response.status === 403) {
            await this.$store.dispatch('directNotification', {
              type: 'error',
              message:
                'Sorry! You are not authorized to perform this action. Please contact your Tulip Admin.',
              description: e.response.data.message,
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          } else {
            await this.$store.dispatch('directNotification', {
              type: 'error',
              message: 'Form cannot be saved, Please enter valid details',
              description: e.response
                ? e.response.data.message
                : 'Error unknown! Kindly retry',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          }
        }
      } else {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to save Form',
          description: 'Form could not be saved due to unidentified route',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },

    backToList() {
      this.$router
        .push({
          name: 'honey-form-detail',
          params: { hexId: this.hexId }
        })
        .catch()
    },

    getJsonProposal(json) {
      this.proposals = json
    }
  }
}
</script>

<style scoped></style>
